// extracted by mini-css-extract-plugin
export var productImage = "_n0-0";